import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { Tooltip } from '../../Tooltip';
import { Indicator } from '../../Indicator';

var getRootBaseStyle = function getRootBaseStyle(_ref) {
  var theme = _ref.theme;
  return theme.componentOverrides.FormFieldTooltip.Root.base;
};

export var FormFieldTooltipRoot = styled(Tooltip)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n"])), getRootBaseStyle);

var getIndicatorBaseStyle = function getIndicatorBaseStyle(_ref2) {
  var theme = _ref2.theme;
  return theme.componentOverrides.FormFieldTooltip.Indicator.base;
};

var getIndicatorDynamicStyle = function getIndicatorDynamicStyle(_ref3) {
  var visible = _ref3.visible;
  return visible ? '' : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n              opacity: 0;\n              pointer-events: none;\n          "])));
};

export var FormFieldTooltipIndicator = styled(Indicator)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n\n    ", ";\n    ", ";\n"])), getIndicatorBaseStyle, getIndicatorDynamicStyle);